import {
  border,
  BorderProps,
  color,
  compose,
  flexbox,
  FlexboxProps,
  WidthProps,
  width,
  HeightProps,
  height,
  MinWidthProps,
  minWidth,
  MinHeightProps,
  minHeight,
  MaxWidthProps,
  maxWidth,
  MaxHeightProps,
  maxHeight,
  DisplayProps,
  display,
  VerticalAlignProps,
  verticalAlign,
  OverflowProps,
  overflow,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  background,
  BackgroundProps,
  grid,
  GridProps,
  ZIndexProps,
  ResponsiveValue as StyledResponsiveValue,
  FontStyleProps,
  TextAlignProps,
  LetterSpacingProps,
  overflowY,
  overflowX,
  Theme as StyledSystemTheme,
  system
} from 'styled-system'
import { Interpolation as StyledInterpolation } from '@emotion/styled'

import {
  ColorProps,
  FontSizeProps,
  FontWeightProps,
  LineHeightProps,
  FontFamilyProps,
  BorderRadiusProps
} from './types'

const gap = system({
  gap: {
    property: 'gap',
    scale: 'space'
  }
})

const textDecoration = system({
  textDecoration: {
    property: 'textDecoration'
  }
})

export type ResponsiveValue<
  P,
  T extends StyledSystemTheme
> = StyledResponsiveValue<P, T>
export type Interpolation<P> = StyledInterpolation<P>

export const systemProps = compose(
  space,
  typography,
  color,
  width,
  height,
  minWidth,
  minHeight,
  maxWidth,
  maxHeight,
  display,
  verticalAlign,
  overflow,
  overflowY,
  overflowX,
  flexbox,
  border,
  background,
  position,
  grid,
  shadow,
  gap,
  textDecoration
)

export interface SystemProps
  extends FontSizeProps,
    FontWeightProps,
    LineHeightProps,
    FontFamilyProps,
    FontStyleProps,
    TextAlignProps,
    PositionProps,
    LetterSpacingProps,
    SpaceProps,
    ShadowProps,
    ColorProps,
    Omit<BorderProps, 'borderRadius'>,
    FlexboxProps,
    WidthProps,
    HeightProps,
    MinWidthProps,
    MinHeightProps,
    MaxWidthProps,
    MaxHeightProps,
    DisplayProps,
    VerticalAlignProps,
    OverflowProps,
    BackgroundProps,
    GridProps,
    ZIndexProps,
    BorderRadiusProps {}

export const systemPropNames = systemProps.propNames as (keyof SystemProps)[]
